// extracted by mini-css-extract-plugin
module.exports = {"dragOverlay":"dndList_dragOverlay__VW6cP"};